export default class ZoomApiError extends Error {
  public code: string;
  public requestId: string;
  /** @hidden */
  constructor(message: string, code: string, requestId: string) {
    super(message);
    this.code = code;
    this.requestId = requestId;
    Object.setPrototypeOf(this, ZoomApiError.prototype);
  }
}
